<template>
    <div class="studio-process-container">
        <div class="studio-process-bottom">
            <div class="product-studio-endingtitle">
                <CommonComponentsUnionTitleProductsEnding product-type="Studio" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import pic from '@assets/imgs/Products/Studio/Process/woman.png';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();

    const data = {
        colorIndex: 2,
        pic,
        textList: ['global_studio_process_card_0', 'global_studio_process_card_1', 'global_studio_process_card_2'],
    };
    const functionTitle: FunctionTitle = {
        colorTitle: 'global_studio_colorTitle',
        title: 'global_studio_title_3',
    };
    onMounted(() => {
        addFadeIn('.studio-process-card-woman ');
    });
</script>

<style lang="less" scoped>
    .studio-process-container {
        .studio-process {
            &-title {
                max-width: 70%;
                margin: .convert(149px) [ @vw] 0 .convert(78px) [ @vw] .convert(80px) [ @vw];
                // text-align: center;
                @media (max-width: @screen-mobile-width) {
                    width: .convert(280px) [ @vw-mobile];
                }
            }

            &-card {
                border-radius: 20px;
                background: #262626;
                // display: flex;
                position: relative;
                padding: .convert(133px) [ @vw];
                padding-left: .convert(85px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    // width: .convert(280px) [ @vw-mobile];
                    padding: .convert(26px) [ @vw-mobile] 0 .convert(36px) [ @vw-mobile] .convert(20px) [ @vw-mobile];
                }
                .studio-info-all {
                    max-width: 85%;

                    font-size: .convert(28px) [ @vw];
                    line-height: normal;
                    display: flex;
                    gap: .convert(32px) [ @vw]; //32px
                    flex-direction: column;
                    justify-content: space-between;
                    line-height: 160%;
                    font-family: 'HarmonyOS Sans SC';

                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(@font-size-md) [ @vw-mobile]; //14px
                        line-height: 160%;
                        width: .convert(220px) [ @vw-mobile];
                        gap: .convert(15px) [ @vw-mobile];
                    }
                    .studio-info {
                        display: flex;
                        .studio-info-yes {
                            margin-right: .convert(@margin-sm) [ @vw]; //12
                            width: .convert(18px) [ @vw];
                            height: .convert(38px) [ @vw];
                            flex-shrink: 0;

                            @media (max-width: @screen-mobile-width) {
                                font-size: .convert(@font-size-xm) [ @vw-mobile]; //14px
                                width: .convert(8px) [ @vw-mobile];
                                height: .convert(16px) [ @vw-mobile];
                            }
                            .svg-check-icon {
                                width: 100%;
                                height: auto;
                            }
                        }
                        .studio-info-title {
                            @media (max-width: @screen-mobile-width) {
                                width: .convert(209px) [ @vw-mobile];
                            }
                        }
                    }
                }
                .card-woman {
                    position: absolute;
                    right: 0;
                    bottom: 0; //_
                    width: .convert(369px) [ @vw];
                    height: .convert(813px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        width: .convert(112px) [ @vw-mobile];
                        // height: .convert(248px) [ @vw-mobile];
                        height: auto;
                        right: -2%;
                        bottom: 12%; //_
                    }
                    .studio-process-card-woman {
                        width: 100%;
                    }
                }
            }

            &-bottom {
                position: relative;
                height: .convert(1000px) [ @vw];
                // @media (max-width: @screen-mobile-width) {
                //     height: .convert(226px) [ @vw-mobile];
                // }
                .product-studio-endingtitle {
                    position: absolute;
                    z-index: 0;
                    width: 100%;
                    padding-top: .convert(214px) [ @vw];
                    padding-bottom: .convert(100px) [ @vw];
                    // @media (max-width: @screen-mobile-width) {
                    //     padding-top: .convert(38px) [ @vw-mobile];
                    //     padding-bottom: .convert(49px) [ @vw-mobile];
                    // }
                }
            }
        }
        :lang(en) {
            .product-studio-endingtitle {
                padding-top: .convert(100px) [ @vw];
            }
        }
    }
</style>
